import { useCallback, useEffect, useState } from 'react';

export function usePersistedState<T>(
  key: string,
  initial: T
): [T, (v: T | ((prev: T) => T)) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key);
      if (stored == null) return initial;
      return JSON.parse(stored) as T;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* quota; ignore */
    }
  }, [key, value]);

  const setAndPersist = useCallback(
    (v: T | ((prev: T) => T)) => {
      setValue((prev) => (typeof v === 'function' ? (v as (p: T) => T)(prev) : v));
    },
    []
  );

  return [value, setAndPersist];
}
